<template lang="pug">
.content
  ed-title-nav(ref='header' :title='$t("Approval Settings")')
    span(slot='action')
      router-link(v-if='$routerHistory.hasHistory() && $route.query["back-to"]' :to='{ path: $routerHistory.previous().path, hash: "" }')
        i.fa.fa-long-arrow-left
        span &nbsp; {{ $t('Back') + ' ' + $t('to') + ' ' + $t($route.query['back-to']) }}

  .container-fluid
    ed-section.active.clear.no-flex.settings-section
      h4 Email Settings
      label.col-md-12.no-pad
        .col-md-3.field-label
          strong Allow users to reply to approval notifications to approve and decline items:
        .col-md-9
          ed-checkbox.text(
            :options=`[{
              label: " ",
              status: settingsCopy.EnableReplyToEmail
            }]`
            v-model='settingsCopy.EnableReplyToEmail'
            @click='canReplyToEmailSetting'
          )
      .clear

      .approval-note(v-if='displayApprovalNoteSettings')
        h4 Approval Note Settings

        label.col-md-12.no-pad
          .col-md-3.field-label
            strong Require Invoice Approval Notes:
          .col-md-9
            ed-checkbox.text(
              :options=`[{
                label: " ",
                status: isRequiredApprovalNote
              }]`
              v-model='isRequiredApprovalNote'
              @click='saveApprovalNoteSettings'
            )

        label.col-md-12.no-pad
          .col-md-3.field-label
            strong &nbsp;&nbsp;&nbsp;&nbsp;Require comment from submitter only
          .col-md-9
            ed-checkbox.text(
              :options=`[{
                label: " ",
                status: requireCommentFromSubmitterOnly
              }]`
              v-model='requireCommentFromSubmitterOnly'
              :disabled='disableSecondApprovalNoteCheckbox'
              @click='saveApprovalNoteSettings'
            )

        .col-md-3.field-label
          label
            strong Approval Note Form Label:
        .col-md-4
            ed-input(v-model='approvalNoteLabel' @change='saveApprovalNoteSettings' required="true" fieldLabel=''
            :error='approvalNoteError' :helptip-body='approvalNoteError && "Please fill in Approval Note." || ""')
        .clear

        .col-md-3.field-label
          label
            strong Submit Invoice Approval Note Prefilled Text:
        .col-md-4
            ed-textarea(v-model='approvalNotePlaceholder'
  			@change='saveApprovalNoteSettings'
              rows="5"
              fieldLabel='')
        .clear

      .col-md-12.no-pad
        ed-modal(
          :show="showModal"
          @show="open"
          @close='closeModal'
          @validate='save'
          :title='title'
          :subtitle='subtitle'
          primaryButton="SAVE"
          :primaryButtonDisabled='primaryButtonDisabled'
          type="large"
          validation
        )
          div(slot="body")
            approval-rule(legacy='true' layout='small')
        h4 Approval Rules
        grid(
          :model='model'
          name=''         
          desc=''
          search=true,
          layout='frame'
          resizing=false
          :endpoint='api.$.approval.getApprovalRules'
          ref='ApprovalRuleGrid'
        )
          span(slot='additionalButtons')
            ed-button.btn.btn-actionbar(
              :disabled='disableSingleButton'
              @click='openRule(ruleId, true)'
            ) Edit

            ed-button.btn.btn-actionbar(
              :disabled='disableSingleButton'
              @click='openDeleteModal(ruleId)'
            ) Delete

            ed-button.btn.btn-actionbar(
              @click="openRule(0, false)"
            ) Add Rule

        ed-modal(
            :show='showDeleteRuleModal' 
            @close='showDeleteRuleModal = false'
            @confirm='deleteRule()'
            title=''
            subtitle='Are you sure you want to delete this rule?'
            primaryButton='Yes'
            secondaryButton='No'
            type='small'
          )

        br
        h4 Approval Rules History        
        approval-history()
      .clear
      br
</template>

<script>

import Grid from '@/components/Grid'
import model from './model'
import ApprovalRule from '../Approval-rule'
import ApprovalHistory from '../Approval-history'
import { EventBus, Eved } from '@/event-bus'
import events from '@/core/events/events'
import settings from '@/components/_modules/Admin/settings'
import user from '@/core/user'

export default {
  components: {
    Grid,
    ApprovalRule,
    ApprovalHistory
  },

  data() {
    return {
      model,
      showModal: false,
      modalApprovalRuleId: 0,
      disableSingleButton: true,
      ruleId: 0,
      showDeleteRuleModal: false,
      ruleToDelete: 0,
      title: '',
      subtitle: '',
      settings: {},
      settingsCopy: {},
      replyToEmailOptions: [],
      primaryButtonDisabled: false,
      approvalNoteLabel: 'Approval Note',
      approvalNotePlaceholder: '',
      isRequiredApprovalNote: false,
      requireCommentFromSubmitterOnly: false,
      disableSecondApprovalNoteCheckbox: false,
      approvalNoteError: false,
      displayApprovalNoteSettings: false
    }
  },

  created() {
    // handle Edit Button availability
    EventBus.$off(Eved.GENERIC.SELECTED_ITEM).$on(Eved.GENERIC.SELECTED_ITEM, r => {
      this.handleButtons(r)
    })
    EventBus.$off(Eved.GENERIC.UNSELECTED_ITEM).$on(Eved.GENERIC.UNSELECTED_ITEM, r => {
      this.handleButtons(r)
    })
    EventBus.$off(Eved.GENERIC.SELECTED_ALL).$on(Eved.GENERIC.SELECTED_ALL, r => {
      this.handleButtons(r)
    })
    EventBus.$off(Eved.GENERIC.UNSELECTED_ALL).$on(Eved.GENERIC.UNSELECTED_ALL, r => {
      this.handleButtons(r)
    })
    EventBus.$on(events.APPROVAL_RULE.REFRESH, r => {
      this.refresh()
    })
    EventBus.$off(events.APPROVAL_RULE.VALIDATION_PASSED).$on(events.APPROVAL_RULE.VALIDATION_PASSED, r => {
      this.closeModal()
    })
    EventBus.$off(events.APPROVAL_RULE.ENABLE_SAVE_BUTTON).$on(events.APPROVAL_RULE.ENABLE_SAVE_BUTTON, r => {
      this.enableSaveButton()
    })

    this.initApprovalNoteSection()

    this.settings = this.$user.$.settings // this.updateSettings()
    this.settingsCopy = utils.copy(this.settings)

    this.approvalNoteError = false
  },

  methods: {
    updateSettings(values) {
      const companySettingsCopy = JSON.parse(global.localStorage.getItem('sessionSettings'))
      const updatedCompanySettings = {
        ...companySettingsCopy,
        CompanySettings: values
      }
      global.localStorage.setItem('sessionSettings', JSON.stringify(updatedCompanySettings))
      this.$user.$.settings = values
      return settings.methods.updateSettings.call(this, values)
    },
    refresh() {
      this.$refs.ApprovalRuleGrid.quickSearch()
      this.$refs.ApprovalRuleGrid.onSelectAll(false)
    },

    closeModal() {
      this.showModal = false
      this.$notifications.removeAll()
    },

    enableSaveButton() {
      this.primaryButtonDisabled = false
      this.$store.state.enableSaveButton = true
    },

    openRule(ruleId, isEdit) {
      if (isEdit) {
        this.title = 'Edit Approval Rule'
        this.subtitle = 'Edit custom rules to trigger approvals.'
        this.primaryButtonDisabled = true
        this.$store.state.enableSaveButton = false
      } else {
        this.title = 'Add Approval Rule'
        this.subtitle = 'Add custom rules to trigger approvals.'
        this.primaryButtonDisabled = false
        this.$store.state.enableSaveButton = true
      }

      this.modalApprovalRuleId = ruleId
      this.showModal = true
    },

    open() {
      var payload = {
        id: this.modalApprovalRuleId
      }
      EventBus.$emit(events.APPROVAL_RULE.OPENED, payload)
    },

    openDeleteModal(ruleId) {
      this.showDeleteRuleModal = true
      this.ruleToDelete = ruleId
    },

    save() {
      EventBus.$emit(events.APPROVAL_RULE.SAVED)
    },

    deleteRule() {
      this.showDeleteRuleModal = false
      if (this.ruleToDelete && this.ruleToDelete > 0) {
        var payload = {
          ruleId: this.ruleToDelete
        }
        this.api.forms.post(this.api.$.approval.deleteRule, payload).then(this.validateDeleteRule)
      } else {
        alert('Cannot delete this rule. Id is undefined')
      }
    },

    validateDeleteRule(r) {
      if (r.data === false) {
        alert('Something went wrong. Could not delete this rule.')
      } else {
        EventBus.$emit(events.APPROVAL_RULE.REFRESH)
      }
    },

    handleButtons(r) {
      if (r && r.data && r.data.length === 1) {
        this.disableSingleButton = false
        this.ruleId = r.data[0].ApprovalRuleId
      } else {
        this.disableSingleButton = true
        this.ruleId = 0
      }
    },

    canReplyToEmailSetting(e) {
      if (!e.status) {
        this.settingsCopy.EnableReplyToEmail = false
      } else {
        this.settingsCopy.EnableReplyToEmail = true
      }
      this.saveSettings()
    },

    saveSettings(setting) {
      var payload = {
        canReply: this.settingsCopy.EnableReplyToEmail
      }
      this.api.forms.post(this.api.$.approval.saveSettings, payload)
        .then(r => {
          this.updateSettings(this.settingsCopy)
        }).catch(e => {
          this.settingsCopy = utils.copy(this.settings)
        })
    },

    initApprovalNoteSection() {
      let userSettings = user.get().data
      if (userSettings && userSettings.IsE360 === false) {
        this.displayApprovalNoteSettings = true

        this.api.forms.get(this.api.$.approval.initApprovalNote)
          .then(r => {
            this.isRequiredApprovalNote = r.data.isRequired
            this.requireCommentFromSubmitterOnly = r.data.requireCommentFromSubmitterOnly
            this.disableSecondApprovalNoteCheckbox = !this.isRequiredApprovalNote
            this.approvalNoteLabel = r.data.label
            this.approvalNotePlaceholder = r.data.placeholder
          })
      } else {
        this.displayApprovalNoteSettings = false
      }
    },

    isValidApprovalNote() {
      if (!this.approvalNoteLabel || this.approvalNoteLabel.trim() === '') {
        this.approvalNoteError = true
        return false
      } else {
        this.approvalNoteError = false
      }
      return true
    },

    saveApprovalNoteSettings() {
      if (!this.isRequiredApprovalNote) {
        this.requireCommentFromSubmitterOnly = false
        this.disableSecondApprovalNoteCheckbox = true
      } else {
        this.disableSecondApprovalNoteCheckbox = false
      }

      if (this.isValidApprovalNote()) {
        this.api.forms.post(this.api.$.approval.saveApprovalNote, {
          isRequired: this.isRequiredApprovalNote,
          requireCommentFromSubmitterOnly: this.requireCommentFromSubmitterOnly,
          label: this.approvalNoteLabel,
          placeholder: this.approvalNotePlaceholder
        })
      }
    }
  }
}

</script>

<style lang="scss" scoped>

.settings-section.settings-section.settings-section.settings-section[class] {
  padding: 0 1em;

  .field-label {
    padding-right: 0;
    padding-left: 13px;
  }

  >>> .page-section-main {
    padding-top: 1px;

    .form-group {
      margin-bottom: 3px;

      .form-control {
        font-size: 12px;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/_modules/Approvals/Approval-list/index.vue